module.exports = __webpack_public_path__ + "img/tick-double.ec328b2d.svg";